// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__XG3SY","rows":"Monitor_rows__VaUGs","boxes":"Monitor_boxes__xXozA","attitude":"Monitor_attitude__ELk-p"};